import CustomDatePickerRange from 'shared-assets/components/CustomDatePicker';

angular
    .module('app.shared-components.date-picker-range', [
        'react'
    ])
    .directive('datePickerRange', datePickerRange);


datePickerRange.$inject = ['reactDirective'];
function datePickerRange(reactDirective) {
    return reactDirective(CustomDatePickerRange);
}